import FeatureDetail from './FeatureDetail'

export default FeatureDetail
